import React from 'react';

import { useRequiredParams } from 'utils';
import { AccountsCard } from 'views/portfolio/PortfolioPage/tabs/overview/AccountsCard';
import { AllocationCard } from 'views/portfolio/PortfolioPage/tabs/overview/AllocationCard';
import { EquityPreferencesCard } from 'views/portfolio/PortfolioPage/tabs/overview/EquityPreferencesCard';
import { GeneralCard } from 'views/portfolio/PortfolioPage/tabs/overview/GeneralCard';
import { LiquidityPlanningCard } from 'views/portfolio/PortfolioPage/tabs/overview/LiquidityPlanningCard';
import { TaxProfileCard } from 'views/portfolio/PortfolioPage/tabs/overview/TaxProfileCard';

export interface OverviewTabContentProps {
    accountGroupGUID: string;
}

// Pure component that takes props (for Storybook testing)
export const OverviewTabContent: React.FC<OverviewTabContentProps> = ({ accountGroupGUID }) => {
    return (
        <div className="space-y-6">
            <div className="grid grid-cols-4 gap-6">
                <GeneralCard />
                <AccountsCard className="col-span-3" accountGroupGUID={accountGroupGUID} />
            </div>
            <div className="grid grid-cols-4 items-start gap-6">
                <AllocationCard accountGroupGUID={accountGroupGUID} />
                <LiquidityPlanningCard accountGroupGUID={accountGroupGUID} />
                <TaxProfileCard accountGroupGUID={accountGroupGUID} />
                <EquityPreferencesCard accountGroupGUID={accountGroupGUID} />
            </div>
        </div>
    );
};

// Container component that fetches data (for routing)
export const OverviewTab: React.FC = () => {
    const { accountGroupGUID } = useRequiredParams(['accountGroupGUID']);
    return <OverviewTabContent accountGroupGUID={accountGroupGUID} />;
};
